import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogDistribuidor = ({ open, initial, onClose }) => {
    const validationSchema = yup.object({
        designacao: yup.string().required('O campo é obrigatório'),
        nif: yup.string().min(9, 'NIF tem de ter 9 dígitos').required('O campo é obrigatório'),
        email: yup.string().email('Email inválido').required('O campo é obrigatório'),
        email2: yup.string().email('Email inválido').notRequired(),
        email3: yup.string().email('Email inválido').notRequired(),
        contacto: yup.string().notRequired(),
        morada: yup.string().notRequired(),
        cep: yup.string().matches(/^\d{4}-\d{3}$/, 'Código Postal deve estar no formato XXXX-YYY').notRequired(),
        localidade: yup.string().notRequired(),
        observacoes: yup.string().notRequired()
    });
    const formik = useFormik({
        initialValues: {
            designacao: initial?.designacao ?? '',
            nif: initial?.nif ?? '',
            email: initial?.email ?? '',
            email2: initial?.email2 ?? '',
            email3: initial?.email3 ?? '',
            contacto: initial?.contacto ?? '',
            morada: initial?.morada ?? '',
            cep: initial?.cep ?? '',
            localidade: initial?.localidade ?? '',
            observacoes: initial?.observacoes ?? '',
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    useEffect(() => {
        if (!open || !initial)
            return;
        formik.resetForm({
            values: {
                designacao: initial?.designacao ?? '',
                nif: initial?.nif ?? '',
                email: initial?.email ?? '',
                email2: initial?.email2 ?? '',
                email3: initial?.email3 ?? '',
                contacto: initial?.contacto ?? '',
                morada: initial?.morada ?? '',
                cep: initial?.cep ?? '',
                localidade: initial?.localidade ?? '',
                observacoes: initial?.observacoes ?? '',
            }
        });
        formik.setValues(initial);
    }, [initial]);
    return (<form>
      <Dialog open={open} maxWidth={'lg'} fullWidth>
        <DialogTitle>Editar Distribuidor</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={8} md={8} xs={8}>
              <TextField label='Designação' name='designacao' fullWidth value={formik.values?.designacao ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.designacao && Boolean(formik.errors.designacao)} helperText={formik.touched.designacao && formik.errors.designacao}/>
            </Grid>
            <Grid lg={4} md={4} xs={4}>
              <TextField label='NIF' name='nif' value={formik.values?.nif ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.nif && Boolean(formik.errors.nif)} helperText={formik.touched.nif && formik.errors.nif}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={4} md={4} xs={12}>
              <TextField label='Email' name='email' value={formik.values?.email ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email}/>
            </Grid>
            <Grid lg={4} md={4} xs={12}>
              <TextField label='Email Alternativo' name='email2' value={formik.values?.email2 ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.email2 && Boolean(formik.errors.email2)} helperText={formik.touched.email2 && formik.errors.email2}/>
            </Grid>
            <Grid lg={4} md={4} xs={12}>
              <TextField label='Email Alternativo 2' name='email3' value={formik.values?.email3 ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.email3 && Boolean(formik.errors.email3)} helperText={formik.touched.email3 && formik.errors.email3}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={4} md={4} xs={12}>
              <TextField label='Contacto' name='contacto' value={formik.values?.contacto ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.contacto && Boolean(formik.errors.contacto)} helperText={formik.touched.contacto && formik.errors.contacto}/>
            </Grid>
            <Grid lg={8} md={8} xs={12}>
              <TextField label='Morada' name='morada' value={formik.values?.morada ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.morada && Boolean(formik.errors.morada)} helperText={formik.touched.morada && formik.errors.morada}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={4} md={4} xs={12}>
              <TextField label='Código Postal' name='cep' value={formik.values?.cep ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.cep && Boolean(formik.errors.cep)} helperText={formik.touched.cep && formik.errors.cep}/>
            </Grid>
            <Grid lg={8} md={8} xs={12}>
              <TextField label='Localidade' name='localidade' value={formik.values?.localidade ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.localidade && Boolean(formik.errors.localidade)} helperText={formik.touched.localidade && formik.errors.localidade}/>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Observações' name='observacoes' value={formik.values?.observacoes ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.observacoes && Boolean(formik.errors.observacoes)} helperText={formik.touched.observacoes && formik.errors.observacoes}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </form>);
};
export default DialogDistribuidor;
